import { render } from "./FillGapWithChoiceExerciseComponent.vue?vue&type=template&id=d5ffbc74&scoped=true"
import script from "./FillGapWithChoiceExerciseComponent.vue?vue&type=script&lang=js"
export * from "./FillGapWithChoiceExerciseComponent.vue?vue&type=script&lang=js"

import "./FillGapWithChoiceExerciseComponent.vue?vue&type=style&index=0&id=d5ffbc74&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5ffbc74"]])

export default __exports__